import $ from 'jquery';

export const imageSlider = () => {
  $('.slider-rows__image').twentytwenty({
    no_overlay: true,
  });
};
